import type {
    TimeGranularity} from "@@/shared/date-time/time-granularity";
import {
    timeGranularityZodSchema,
} from "@@/shared/date-time/time-granularity";
import { z } from "zod";
import type {
    DurationBaseLength} from "../bookable-base-length";
import {
    durationBaseLengthZodSchema,
} from "../bookable-base-length";

type BookableSessionAvailability = DropIn;

type DropIn = {
    _type: "DROP_IN";
    granularity: TimeGranularity;
    duration: DurationBaseLength;
};

const bookableSessionAvailabilityZodSchema: z.ZodSchema<BookableSessionAvailability> =
    z.object({
        _type: z.literal("DROP_IN"),
        granularity: timeGranularityZodSchema,
        duration: durationBaseLengthZodSchema,
    });

export type { BookableSessionAvailability };
export { bookableSessionAvailabilityZodSchema };
